import { render, staticRenderFns } from "./ScreenConfigureWizardObject.vue?vue&type=template&id=57c42f5e&scoped=true&"
import script from "./ScreenConfigureWizardObject.vue?vue&type=script&lang=js&"
export * from "./ScreenConfigureWizardObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c42f5e",
  null
  
)

export default component.exports